import { useNavigate } from "react-router-dom";
//Props Validations
import PropTypes from "prop-types";

// import mui components
import IconButton from "@mui/material/IconButton";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import AutoGraphRoundedIcon from "@mui/icons-material/AutoGraphRounded";
import CrossCompareKeyMetricsIcon from "../../assets/icons/CrossCompareKeyMetricsICon.png";

function MatchNetNavigation({ buttons = [], isDisabled = false }) {
    const disabledColor = "#D8D8D8";
    const navigate = useNavigate();

    const buttonStyles = () => {
        if (buttons.length === 5) {
            return `
                .buttons:hover .button-position-4 {
                    translate: 110px 0px;
                }
                
                .buttons:hover .button-position-3 {
                    translate: 60px -50px;
                }

                .buttons:hover .button-position-2 {
                    translate: 0px -80px;
                }

                .buttons:hover .button-position-1 {
                    translate: -60px -50px;                      
                }

                .buttons:hover .button-position-0 {
                    translate: -110px 0px;
                }
            `;
        } else if (buttons.length === 4) {
            return `
                .buttons:hover .button-position-3 {
                    translate: 80px -25px;
                }

                .buttons:hover .button-position-2 {
                    translate: 30px -70px;
                }

                .buttons:hover .button-position-1 {
                    translate: -30px -70px                       
                }

                .buttons:hover .button-position-0 {
                    translate: -80px -25px;
                }
            `;
        } else if (buttons.length === 1) {
            return `
                .buttons:hover .button-position-0 {
                    translate: 0px -65px;
                }
            `;
        } else {
            return `
                .buttons:hover .button-position-2 {
                    translate: 70px -30px;
                }

                .buttons:hover .button-position-1 {
                    translate: 0px -65px;
                }

                .buttons:hover .button-position-0 {
                    translate: -70px -30px                       
                }
            `;
        }
    };

    const navigateTo = (route) => {
        navigate(route);
    };

    const buttonDetails = {
        matchNetLookup: {
            icon: <SearchRoundedIcon sx={{ color: "#fff", position: "relative", fontSize: 24 }} />,
            route: "/match-net/lookup",
            label: "MatchNet Lookup",
        },
        CrossCompareKeyMetrics: {
            icon: (
                <img
                    src={CrossCompareKeyMetricsIcon}
                    alt="MatchNet Lookup"
                    style={{
                        width: "24px",
                        height: "24px",
                        margin: "6px",
                        position: "relative",
                        objectFit: "contain",
                    }}
                />
            ),
            route: "/match-net/cross-study-comparison",
            label: "Cross Compare Key Metrics",
        },
    };

    const getButtonDetails = (btn, type) => {
        let btnInfo = buttonDetails[btn];

        return btnInfo[type];
    };

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
            }}
        >
            <style>
                {`
                    .buttons {
                        position: absolute;
                        display: grid;
                        place-items: center;
                        height: fit-content;
                        width: fit-content;
                        transition: 0.3s;
                        top: 5px;
                    }

                    .button span {
                        display: none;
                    }

                    .buttons:hover .button span {
                        display: block;
                    }
 
                    .main-button {
                        position: relative;
                        display: grid;
                        place-items: center;
                        padding: 10px 10px;
                        border: none;
                        background: transparent;
                        transition: 0.2s;
                    }
 
                    .button {
                        background: transparent;
                        position: absolute;
                        display: grid;
                        place-items: center;
                        padding: 10px;
                        border: none;
                        box-shadow: 5px 5px 12px rgba(202, 202, 202, 0), -5px -5px 12px rgba(255, 255, 255, 0);
                        transition: 0.5s;
                        border-radius: 10px;
                    }
                   
                    .button:hover{
                        transform:scale(1.2);
                    }
                    
                    .buttons:hover .button {
                        transition-delay: 0s;
                    }
                    .buttons:not(:hover) .button {
                        transition-delay: 0.5s;
                    }
 
                `}
            </style>
            <style>{buttonStyles()}</style>
            <div
                style={{
                    zIndex: 2,
                }}
            >
                <svg
                    width="162"
                    height="52"
                    viewBox="0 0 152 42"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <defs>
                        <linearGradient
                            id="gradient"
                            x1="0%"
                            y1="0%"
                            x2="100%"
                            y2="0%"
                        >
                            <stop
                                offset="0%"
                                style={{
                                    stopColor: "rgba(71, 163, 255, 1)",
                                    stopOpacity: 1,
                                }}
                            />
                            <stop
                                offset="100%"
                                style={{
                                    stopColor: "rgba(0, 94, 239, 1)",
                                    stopOpacity: 1,
                                }}
                            />
                        </linearGradient>
                    </defs>
                    <path
                        d="M0 41.0513C7.62 39.6013 15 37.6613 22.1 34.6813C31.01 30.9413 38.63 25.4313 45.1 18.2913C47.73 15.3913 50.36 12.4913 53.06 9.66128C58.66 3.81128 65.59 0.611281 73.63 0.081281C83.13 -0.548719 91.42 2.48128 98.19 9.25128C101.28 12.3413 104.18 15.6213 107.12 18.8613C116.51 29.1813 128.31 35.3313 141.66 38.7713C144.96 39.6213 148.28 40.3513 151.25 41.0613C101.12 41.0513 50.62 41.0513 0 41.0513Z"
                        fill="url(#gradient)"
                    />
                </svg>
            </div>
            <div className="buttons">
                <button className="main-button">
                    <AutoGraphRoundedIcon
                        sx={{
                            color: "#fff",
                            zIndex: 2,
                            position: "relative", // Make sure the icon is on top of the background
                        }}
                    />
                </button>

                {buttons.map((btn, index) => {
                    const btnClass = `button-position-${index} button`;
                    const btnIcon = getButtonDetails(btn, "icon");
                    const btnLabel = getButtonDetails(btn, "label");
                    const btnRoute = getButtonDetails(btn, "route");

                    return (
                        <button
                            key={btnClass}
                            className={btnClass}
                            style={{
                                transitionProperty: "translate",
                            }}
                            onClick={() => navigateTo(btnRoute)}
                            disabled={isDisabled}
                            title={isDisabled ? "No data present" : ""}
                        >
                            <>
                                <IconButton
                                    style={{
                                        background: isDisabled ? disabledColor : undefined,
                                        boxShadow: "5px 5px 12px rgba(202, 202, 202, 0), -5px -5px 12px rgba(255, 255, 255, 0)",
                                        padding: "3px",
                                    }}
                                    className={isDisabled ? undefined : "liner-light-blue-background"}
                                    size="small"
                                >
                                    {btnIcon}
                                </IconButton>

                                <span
                                    style={{
                                        fontSize: "9px",
                                        width: "80px",
                                    }}
                                >
                                    {btnLabel}
                                </span>
                            </>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}

// Typechecking props for the MatchNetNavigation
MatchNetNavigation.propTypes = {
    buttons: PropTypes.array,
    isDisabled: PropTypes.bool,
};

export default MatchNetNavigation;
